module.exports = __webpack_public_path__ + "img/20200610_155646.24c9f353.jpg";